import styled from 'styled-components';

export const Container = styled.div`
  padding: 8px;
  color: var(--grey1);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`;
